import React, { Component, PropTypes } from 'react';
import baguetteBox from 'baguettebox.js';
import Masonry from 'react-masonry-component';

export default class Gallery extends Component {
  componentDidMount() {
    baguetteBox.run('.gallery', {
      async: true,
      preload: 5,
    });
  }

  render() {
    const {
      images,
    } = this.props;

    let updatedImages = images;

    if (!Array.isArray(images)) {
      updatedImages = [images];
    }

    return (
      <Masonry
        className="gallery"
        options={{ transitionDuration: 1 }}
      >
        {
          (updatedImages || []).map((image, index) => (
            <a className="gallery-image" key={index} href={image}>
              <img
                role="presentation"
                className="ui image fluid"
                src={image}
              />
            </a>
          ))
        }
      </Masonry>
    );
  }
}

Gallery.propTypes = {
  images: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
  ]),
};
